$('.review-slider__contents').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  prevArrow: $('.review-slider__button.btn-prev'),
  nextArrow: $('.review-slider__button.btn-next'),
  responsive: [
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        infinite: true,
        arrows: false,
      }
    },
  ]
});